export class NotificationPolicyConfigDatadog {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "site",
            "baseName": "site",
            "type": "string",
            "format": ""
        },
        {
            "name": "apiKey",
            "baseName": "apiKey",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationPolicyConfigDatadog.attributeTypeMap;
    }
    constructor() {
    }
}
